module.exports = __webpack_public_path__ + "static/media/heuritech_min.3bdc3073.svg";